import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b0cc1f4c&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "@/assets/monitor.less?vue&type=style&index=0&id=b0cc1f4c&lang=less&scoped=true&"
import style1 from "./index.vue?vue&type=style&index=1&id=b0cc1f4c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0cc1f4c",
  null
  
)

export default component.exports